"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _NavSettings = _interopRequireDefault(require("../NavSettings/NavSettings"));

var _NavToolbar = _interopRequireDefault(require("../NavToolbar/NavToolbar"));

var _NavTabs = _interopRequireDefault(require("../NavTabs/NavTabs"));

var _ModuleTitle = _interopRequireDefault(require("./ModuleTitle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  header: {
    display: "flex",
    zIndex: 2,
    alignItems: "center",
    justifyContent: "flex-start",
    height: theme.spacing(7),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: "inherit",
    "& + *": {
      zIndex: 1,
      marginTop: theme.spacing(7)
    }
  },
  title: {
    flexGrow: 1,
    marginLeft: theme.spacing(1),
    color: "inherit",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "bold"
  },
  navTabs: {
    flexGrow: 1,
    marginLeft: theme.spacing(1),
    color: "inherit"
  },
  navSettings: {
    display: "flex"
  },
  navToolbar: {
    display: "flex",
    color: "inherit"
  }
}));

const ModuleHeader = ({
  className,
  status,
  title,
  menu,
  settings,
  toolbar,
  children
}) => {
  const classes = useStyles();

  if (children) {
    return _react.default.createElement("header", {
      className: classes.header
    }, children);
  }

  return _react.default.createElement("header", {
    className: className || classes.header
  }, menu && _react.default.createElement(_NavTabs.default, {
    className: classes.navTabs,
    tabs: menu
  }), !menu && _react.default.createElement(_ModuleTitle.default, {
    lassName: classes.title,
    status: status,
    title: title
  }), settings && _react.default.createElement(_NavSettings.default, {
    className: classes.navSettings,
    settings: settings
  }), toolbar && _react.default.createElement(_NavToolbar.default, {
    className: classes.navToolbar,
    toolbar: toolbar
  }));
};

var _default = ModuleHeader;
exports.default = _default;
module.exports = exports.default;